import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../../../contexts/ThemeContext';
import ProfileTab from './ProfileTab';

function Profile() {
  const { theme } = useTheme();
  const user = useSelector((s) => s.auth.user);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const displayName = user?.respondentName || user?.name || "";
  const initials = displayName ? displayName.charAt(0).toUpperCase() : '?';

  return (
    <div ref={ref} style={styles.wrapper}>
      <button
        onClick={() => setOpen(!open)}
        style={{ ...styles.avatar, backgroundColor: theme.primary }}
      >
        {initials}
      </button>
      {open && <ProfileTab onClose={() => setOpen(false)} />}
    </div>
  );
}

const styles = {
  wrapper: {
    position: 'relative',
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: 600,
  },
};

export default Profile;
